import { Col, Form, Input, Row } from 'antd';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateField } from '../../../../../contextRedux/ProviderWorkPlace/ProviderWorkPlaceModel';
import { RootState } from '../../../../../store';
import './LocationTab.css';

const LocationTab: React.FC = () => {
  const dispatch = useDispatch();

  const [form] = Form.useForm();

  const initialValues = {
    name: useSelector((state: RootState) => state?.models?.providerWorkPlace?.name),
    address: useSelector((state: RootState) => state?.models?.providerWorkPlace?.address),
    details: useSelector((state: RootState) => state?.models?.providerWorkPlace?.details),
  };

  const handleFieldChange = (changedValues: any, _allValues: any) => {
    for (const key in changedValues) {
      dispatch(updateField({ field: key, value: changedValues[key] }));
    }
  };

  return (
    <Form
      form={form}
      name='userForm'
      initialValues={initialValues}
      onValuesChange={handleFieldChange}
      layout='vertical'
      className='providerWorkPlaceForm'
    >
      <Row gutter={[16, 16]} className='row'>
        <Col xs={24} sm={12}>
          <Form.Item
            label='Nume Punct De Depozitare'
            name='name'
            rules={[
              {
                required: true,
                message: 'Introdu denumire de punct de depozitare!',
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12}>
          <Form.Item label='Adresa' name='address' rules={[{ required: true, message: 'Introdu adresa!' }]}>
            <Input />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12}>
          <Form.Item label='Alte detalii' name='details'>
            <Input />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default LocationTab;
